import { createContext } from "react"
import { NotificationSubscribeEvent } from "shared/types/notificationTypes"

export type NotificationContextType = {
    notificationEvent: NotificationSubscribeEvent
}

export const NotificationContext = createContext<NotificationContextType>({
    notificationEvent: null,
})
